// extracted by mini-css-extract-plugin
module.exports = {"dj-news":"news_dj-news__rkYMB","dj-news-content":"news_dj-news-content__3gMV8","enterpriseNews-swiper":"news_enterpriseNews-swiper__3CJwP"};